import s from './WhatIs.module.scss'
import React from 'react'
import { Button } from 'antd'
import { useLanguage } from 'context/LanguageContext'
import { translations } from './translations'

const WhatIs: React.FC = React.memo(() => {
    const { language } = useLanguage()
    const { title, description, button, info } = translations[language]

    return (
        <div className={s.wrapper}>
            <div className={s.intro}>
                <h2 className={s.title}>{title}</h2>
                <p className={s.description}>{description}</p>
                <Button className={s.button} href="#about">
                    {button}
                </Button>
            </div>

            <ul className={s.list}>
                {info.map(({ title: cardTitle, text, icon: Icon }, i) => (
                    <li className={s.item} key={i}>
                        <span className={s.icon}>
                            <Icon />
                        </span>
                        <div>
                            <h3 className={s.cardTitle}>{cardTitle}</h3>
                            <p className={s.text}>{text}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    )
})

export default WhatIs
